// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import PhotoQuality from "./photo-quality.js"
import PhotoSessionGroupContact from "./photo-session-group-contact.js"
import PhotoSheetProduct from "./photo-sheet-product.js"
import PhotoSheetProductOrderLineBox from "./photo-sheet-product-order-line-box.js"
import SheetLayout from "./sheet-layout.js"
import SheetSize from "./sheet-size.js"
import TenantPhotoProduct from "./tenant-photo-product.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_quality_id": {
      "column": {
        "default": null,
        "name": "photo_quality_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_quality_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_contact_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_session_group_contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_sheet_product_id": {
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_sheet_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_size_id": {
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_size_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_photo_product_id": {
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "tenant_photo_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PhotoSheetProductOrderLine",
  "collectionKey": "photo_sheet_product_order_lines",
  "collectionName": "photo_sheet_product_order_lines",
  "i18nKey": "photo_sheet_product_order_line",
  "camelizedLower": "photoSheetProductOrderLine",
  "name": "PhotoSheetProductOrderLine",
  "nameDasherized": "photo-sheet-product-order-line",
  "pluralName": "photo_sheet_product_order_lines",
  "ransackable_associations": [
    {
      "className": "PhotoSheetProductOrderLineBox",
      "collectionName": "photo_sheet_product_order_line_boxes",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineBox",
      "through": null
    },
    {
      "className": "BundleOrderLineElement",
      "collectionName": "bundle_order_line_elements",
      "foreignKey": "resource_id",
      "name": "bundle_order_line_element",
      "macro": "has_one",
      "resource_name": "BundleOrderLineElement",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLineGeneration",
      "collectionName": "photo_sheet_product_order_line_generations",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "generations",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineGeneration",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "has_one",
      "resource_name": "Order",
      "through": "order_line"
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "orderable_id",
      "name": "order_line",
      "macro": "has_one",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "belongs_to",
      "resource_name": "PhotoProduct",
      "through": null
    },
    {
      "className": "PhotoQuality",
      "collectionName": "photo_qualities",
      "foreignKey": "photo_quality_id",
      "name": "photo_quality",
      "macro": "belongs_to",
      "resource_name": "PhotoQuality",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "has_one",
      "resource_name": "Product",
      "through": "photo_product"
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_product_id",
      "column": {
        "default": null,
        "name": "photo_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_quality_id",
      "column": {
        "default": null,
        "name": "photo_quality_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_session_group_contact_id",
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "photo_sheet_product_id",
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_layout_id",
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_size_id",
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_photo_product_id",
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoSheetProductOrderLineBox",
      "collectionName": "photo_sheet_product_order_line_boxes",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineBox",
      "through": null
    },
    {
      "className": "PhotoQuality",
      "collectionName": "photo_qualities",
      "foreignKey": "photo_quality_id",
      "name": "photo_quality",
      "macro": "belongs_to",
      "resource_name": "PhotoQuality",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product_order_line",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProductOrderLine. */
export default class PhotoSheetProductOrderLine extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoQualityId() {
    return this.readAttributeUnderscore("photo_quality_id")
  }

  /** @returns {boolean} */
  hasPhotoQualityId() {
    const value = this.photoQualityId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionGroupContactId() {
    return this.readAttributeUnderscore("photo_session_group_contact_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupContactId() {
    const value = this.photoSessionGroupContactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSheetProductId() {
    return this.readAttributeUnderscore("photo_sheet_product_id")
  }

  /** @returns {boolean} */
  hasPhotoSheetProductId() {
    const value = this.photoSheetProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutId() {
    return this.readAttributeUnderscore("sheet_layout_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutId() {
    const value = this.sheetLayoutId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetSizeId() {
    return this.readAttributeUnderscore("sheet_size_id")
  }

  /** @returns {boolean} */
  hasSheetSizeId() {
    const value = this.sheetSizeId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  tenantPhotoProductId() {
    return this.readAttributeUnderscore("tenant_photo_product_id")
  }

  /** @returns {boolean} */
  hasTenantPhotoProductId() {
    const value = this.tenantPhotoProductId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate",
        primaryKey: this.primaryKey(),
        collectionName: "photo_sheet_product_order_lines",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-sheet-product-order-line-box.js").default>} */
  boxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_order_line_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "boxes",
        model: this,
        modelClass: PhotoSheetProductOrderLineBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-order-line-box.js").default>>} */
  loadBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_order_line_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "boxes",
        model: this,
        modelClass: PhotoSheetProductOrderLineBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-order-line-box.js").default>>} */
  ensureBoxesLoaded() {
    return this.ensureAssociationLoaded("boxes")
  }

  /** @returns {import("./photo-quality.js").default | null} */
  photoQuality() {
    return this._readBelongsToReflection({modelClass: PhotoQuality, reflectionName: "photo_quality"})
  }

  /** @returns {Promise<import("./photo-quality.js").default | null>} */
  loadPhotoQuality() {
    if (!("photoQualityId" in this)) throw new Error("Foreign key method wasn't defined: photoQualityId")

    const id = this.photoQualityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_quality",
        model: this,
        modelClass: PhotoQuality
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-quality.js").default | null>} */
  ensurePhotoQualityLoaded() {
    return this.ensureAssociationLoaded("photo_quality")
  }

  /** @returns {import("./photo-session-group-contact.js").default | null} */
  photoSessionGroupContact() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroupContact, reflectionName: "photo_session_group_contact"})
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  loadPhotoSessionGroupContact() {
    if (!("photoSessionGroupContactId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupContactId")

    const id = this.photoSessionGroupContactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group_contact",
        model: this,
        modelClass: PhotoSessionGroupContact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  ensurePhotoSessionGroupContactLoaded() {
    return this.ensureAssociationLoaded("photo_session_group_contact")
  }

  /** @returns {import("./photo-sheet-product.js").default | null} */
  photoSheetProduct() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProduct, reflectionName: "photo_sheet_product"})
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  loadPhotoSheetProduct() {
    if (!("photoSheetProductId" in this)) throw new Error("Foreign key method wasn't defined: photoSheetProductId")

    const id = this.photoSheetProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product",
        model: this,
        modelClass: PhotoSheetProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  ensurePhotoSheetProductLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product")
  }

  /** @returns {import("./sheet-layout.js").default | null} */
  sheetLayout() {
    return this._readBelongsToReflection({modelClass: SheetLayout, reflectionName: "sheet_layout"})
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  loadSheetLayout() {
    if (!("sheetLayoutId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutId")

    const id = this.sheetLayoutId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout",
        model: this,
        modelClass: SheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  ensureSheetLayoutLoaded() {
    return this.ensureAssociationLoaded("sheet_layout")
  }

  /** @returns {import("./sheet-size.js").default | null} */
  sheetSize() {
    return this._readBelongsToReflection({modelClass: SheetSize, reflectionName: "sheet_size"})
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  loadSheetSize() {
    if (!("sheetSizeId" in this)) throw new Error("Foreign key method wasn't defined: sheetSizeId")

    const id = this.sheetSizeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_size",
        model: this,
        modelClass: SheetSize
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  ensureSheetSizeLoaded() {
    return this.ensureAssociationLoaded("sheet_size")
  }

  /** @returns {import("./tenant-photo-product.js").default | null} */
  tenantPhotoProduct() {
    return this._readBelongsToReflection({modelClass: TenantPhotoProduct, reflectionName: "tenant_photo_product"})
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  loadTenantPhotoProduct() {
    if (!("tenantPhotoProductId" in this)) throw new Error("Foreign key method wasn't defined: tenantPhotoProductId")

    const id = this.tenantPhotoProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant_photo_product",
        model: this,
        modelClass: TenantPhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  ensureTenantPhotoProductLoaded() {
    return this.ensureAssociationLoaded("tenant_photo_product")
  }
}
